function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import BaseModule from './BaseModule';

var Keyboard = /*#__PURE__*/function (_BaseModule) {
  _inherits(Keyboard, _BaseModule);

  var _super = _createSuper(Keyboard);

  function Keyboard() {
    _classCallCheck(this, Keyboard);

    return _super.apply(this, arguments);
  }

  _createClass(Keyboard, [{
    key: "onCreate",
    value: function onCreate(e) {
      var _this = this;

      this.keyboardProxy = function (evt) {
        return _this.keyboardHandle(evt);
      };

      document.addEventListener('keydown', this.keyboardProxy, true);
    }
  }, {
    key: "onDestroy",
    value: function onDestroy() {
      document.removeEventListener('keydown', this.keyboardProxy, true);
    }
  }, {
    key: "keyboardHandle",
    value: function keyboardHandle(evt) {
      if (evt.defaultPrevented) return;

      if (evt.shiftKey || evt.ctrlKey || evt.altKey) {
        return;
      }

      if (!this.activeEle || evt.fromResize || evt.ctrlKey) return;
      var code = evt.keyCode;
      var index = this.blot.offset(this.quill.scroll);
      var nextBlot;
      var handled = false; // delete

      if (code === Keyboard.keys.BACKSPACE || code === Keyboard.keys.DELETE) {
        this.blot.deleteAt(0);
        this.blot.parent.optimize();
        handled = true; // direction key
      } else if (code >= Keyboard.keys.LEFT && code <= Keyboard.keys.DOWN) {
        if (code === Keyboard.keys.RIGHT) {
          index++;
        } else if (code === Keyboard.keys.UP) {
          index = this.getOtherLineIndex(-1);
          nextBlot = this.quill.getLeaf(index)[0];
        } else if (code === Keyboard.keys.DOWN) {
          index = this.getOtherLineIndex(1);
          nextBlot = this.quill.getLeaf(index)[0];
        }

        handled = true;
      }

      if (handled) {
        evt.stopPropagation();
        evt.preventDefault();
      }

      if (nextBlot && this.resizer.judgeShow(nextBlot, nextBlot.domNode)) return;
      this.quill.setSelection(index);
      this.resizer.hide();
    }
  }, {
    key: "getOtherLineIndex",
    value: function getOtherLineIndex(dir) {
      var index = this.blot.offset(this.quill.scroll);

      var _this$quill$getLine = this.quill.getLine(index),
          _this$quill$getLine2 = _slicedToArray(_this$quill$getLine, 1),
          line = _this$quill$getLine2[0];

      var lineIndex = this.blot.offset(line) + 1;
      var otherLine = dir > 0 ? line.next : line.prev;

      if (otherLine) {
        var len = otherLine.length();
        if (otherLine.statics.blotName === 'block') len--;
        index = otherLine.offset(this.quill.scroll) + Math.min(len, lineIndex);
      }

      return index;
    } // 转发event到quill

  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(evt) {
      var event = new evt.constructor(evt);
      event.fromResize = true;
      this.quill.root.dispatchEvent(event);
    }
  }], [{
    key: "injectInit",
    value: function injectInit(quill) {
      // left/right
      var bindings = quill.keyboard.bindings;
      bindings[this.keys.LEFT].unshift(this.makeArrowHandler(this.keys.LEFT, false));
      bindings[this.keys.RIGHT].unshift(this.makeArrowHandler(this.keys.RIGHT, false)); // // up
      // const upBinding = this.makeArrowHandler(this.keys.UP, false)
      // if (bindings[this.keys.UP]) {
      //   bindings[this.keys.UP].unshift(upBinding)
      // } else {
      //   quill.keyboard.addBinding(upBinding)
      // }
      // // down
      // const downBinding = this.makeArrowHandler(this.keys.DOWN, false)
      // if (bindings[this.keys.DOWN]) {
      //   bindings[this.keys.DOWN].unshift(downBinding)
      // } else {
      //   quill.keyboard.addBinding(downBinding)
      // }
    }
  }, {
    key: "makeArrowHandler",
    value: function makeArrowHandler(key, shiftKey) {
      var _ref;

      var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
      return _ref = {
        key: key,
        shiftKey: shiftKey,
        altKey: null
      }, _defineProperty(_ref, where, /^$/), _defineProperty(_ref, "handler", function handler(range) {
        if (!this.quill.resizer) return true;
        var index = range.index; // check end of line

        var _this$quill$getLine3 = this.quill.getLine(range.index),
            _this$quill$getLine4 = _slicedToArray(_this$quill$getLine3, 1),
            line = _this$quill$getLine4[0];

        var lineIndex = this.quill.getIndex(line);
        if (key === Keyboard.keys.RIGHT && lineIndex + line.length() - 1 === index) return true; // get leaf/offset

        if (key === Keyboard.keys.RIGHT) {
          index += range.length + 1;
        }

        var _this$quill$getLeaf = this.quill.getLeaf(index),
            _this$quill$getLeaf2 = _slicedToArray(_this$quill$getLeaf, 1),
            leaf = _this$quill$getLeaf2[0];

        var offset = leaf.offset(leaf.parent); // check start of line

        if (key === Keyboard.keys.LEFT && (index === 0 || index === lineIndex)) return true; // get previous leaf

        if (key === Keyboard.keys.LEFT) {
          if (offset === 0) {
            index -= 1;
            leaf = this.quill.getLeaf(index)[0];
          }
        }

        return !this.quill.resizer.judgeShow(leaf);
      }), _ref;
    }
  }]);

  return Keyboard;
}(BaseModule);

export { Keyboard as default };
Keyboard.keys = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46
};